module.exports = __webpack_public_path__ + "ea6532d7b9cda969352affc0cc5a7ffc.svg";